var scope_0 = require('/home/runner/work/995749721/995749721/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/37ef8adfc2f6dc30d913fcc392812a29.js').default;
var scope_1 = require('/home/runner/work/995749721/995749721/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4b5da61179798a63e3aefd539fc6efb5.js').default;
var scope_2 = require('/home/runner/work/995749721/995749721/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e8c16061c459226e6d68f5eee61d0900.js').default;
var scope_3 = require('/home/runner/work/995749721/995749721/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    